export default __webpack_public_path__ + "static/lalibrairie-s-desktop-882ca3e5b51c3d97af6a1ddd45b85bc1.jpg";